export const actionTypes = {
  RESOLVE: 'RESOLVE',
  REJECT: 'REJECT',
  SET_SELECTED_TIER: 'SET_SELECTED_TIER',
  SET_PRODUCT_LIST: 'SET_PRODUCT_LIST',
  SET_SELECTED_MULTIYEAR_PLAN: 'SET_SELECTED_MULTIYEAR_PLAN',
  SET_AMC_PLANS: 'SET_AMC_PLANS',
  SET_BENEFITS: 'SET_BENEFITS',
  SET_PER_YEAR_PRICE: 'SET_PER_YEAR_PRICE',
  ENABLE_PURCHASE_BUTTON: 'ENABLE_PURCHASE_BUTTON',
  CHANGE_SERVICE_COMPONENT: 'CHANGE_SERVICE_COMPONENT',
  SET_BOOK_A_SERVICE_TRIGGERED_FROM: 'SET_BOOK_A_SERVICE_TRIGGERED_FROM',
  UPDATE_SERVICE_TYPE: 'UPDATE_SERVICE_TYPE',
  SET_CART_COUPONS_APPLIED: 'SET_CART_COUPONS_APPLIED',
  BACK_CTA: 'BACK_CTA',
  SET_PAYMENT_SUMMARY: 'SET_PAYMENT_SUMMARY',
  SET_ASSISTANT_CODE: 'SET_ASSISTANT_CODE',
  SET_IS_ASSISTANT_CODE_VALID: 'SET_IS_ASSISTANT_CODE_VALID',
  SET_NCEMI_PROMOTION: 'SET_NCEMI_PROMOTION',
  SET_BANK_CASHBACK_PROMOTION: 'SET_BANK_CASHBACK_PROMOTION',
  SET_BNPL_PROMOTION: 'SET_BNPL_PROMOTION',
  SET_AMC_SERVICE_DETAILS: 'SET_AMC_SERVICE_DETAILS',
  SERVICE_ALLOCATION: {
    RESET_STATE: 'RESET_STATE',
    UPDATE_DEFECT_TYPE: 'UPDATE_DEFECT_TYPE',
    UPDATE_SERVICE_DATE: 'UPDATE_SERVICE_DATE',
    UPDATE_SERVICE_SLOT: 'UPDATE_SERVICE_SLOT',
    INTIALIZE_CONTEXT: 'SERVICE_ALLOCATION:INTIALIZE_CONTEXT',
    INITIALIZE_REQ_HISTORY: 'SERVICE_ALLOCATION:INITIALIZE_REQ_HISTORY',
    DATE_SELECTION_METHOD: 'SERVICE_ALLOCATION:DATE_SELECTION_METHOD',
    INITIALIZE_SR_WEBENGAGE: 'SERVICE_ALLOCATION:INITIALIZE_SR_WEBENGAGE',
  },
  SET_RESCHEDULE_FLOW: 'SET_RESCHEDULE_FLOW',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  UPDATE_ADDRESS: 'UPDATE_ADDRESS',
  UPDATE_USE_CURRENT_ADDRESS: 'UPDATE_USE_CURRENT_ADDRESS',
  SET_SERVICE_REQUEST_ID: 'SET_SERVICE_REQUEST_ID',
  SET_STATUS: 'SET_STATUS',
  SET_IS_ROUTING: 'SET_IS_ROUTING',
  SET_DISABLE_PAGE_SCROLL: 'SET_DISABLE_PAGE_SCROLL',
  SET_ISLOADING: 'SET_ISLOADING',
  SET_INCIDENT_ID: 'SET_INCIDENT_ID',
  SET_RESCHEDULE_REASON: 'SET_RESCHEDULE_REASON',
  SET_WO_DETAILS: 'SET_WO_DETAILS',
  SET_IR_LIST: 'SET_IR_LIST',
};
